import type React from "react"
import { useTranslation } from "react-i18next"

import { SigmaReport } from "@/components/sigma-report"
import { useSiteLayoutContext } from "@/modules/site/context/site-layout-context"
import {
  SigmaWorkbookId,
  allSitesWorkspaceName,
  useSigmaWorkbooks,
} from "@/services/sigma"
import type { SigmaWorkbook } from "@/services/sigma"

export const SiteDetailsRoute: React.FC = () => {
  const { t } = useTranslation("sites")
  const { site } = useSiteLayoutContext()
  const { sigmaWorkbooksData } = useSigmaWorkbooks({
    apiOptions: {
      workspaceNames: [allSitesWorkspaceName],
    },
  })

  const siteDetailWorkbook: SigmaWorkbook | undefined =
    sigmaWorkbooksData?.entries.find(
      (workbook) =>
        (workbook.workbookId as SigmaWorkbookId) === SigmaWorkbookId.SiteDetails
    )

  return (
    <SigmaReport
      reportTitle={t("site.tab.details")}
      siteId={site?.id}
      workbookId={siteDetailWorkbook?.workbookId}
    />
  )
}
